import { useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import { Alert, Button, Grid, Typography } from '@mui/material'

import { AuthenticationContext } from '../../providers/auth-provider'
import { DashboardContext } from '../../providers/dashboard-provider'
import { formatAddress } from '../../utils/helpers'
import useIsMobile from '../../utils/hooks/useIsMobile'
import LocationSelectModal from '../location-select-modal'

import useStyles from './index.styles'

const SelectedFolderBanner = ({ folder, isActivation }: { folder: IFolderType | null; isActivation?: boolean }) => {
  const navigate = useNavigate()
  const location = useLocation()
  const isMobile = useIsMobile()
  const { ownUser } = useContext(AuthenticationContext)
  const { selectedFolderId: folderIdContext } = useContext(DashboardContext)
  const { folderId: folderIdState } = (location.state as { folderId?: number | string } | null) || {}
  const selectedFolderId = folderIdContext ?? (folderIdState ? Number(folderIdState) : null)
  const [showLocationSelectModal, setShowLocationSelectModal] = useState<boolean>(false)
  const classes = useStyles

  // Auto-open the modal if the user has multiple folders but hasn't selected one yet
  useEffect(() => {
    if (ownUser && ownUser.folders.length > 1 && !selectedFolderId) {
      setShowLocationSelectModal(true)
    }
  }, [selectedFolderId, ownUser])

  const handleLocationChange = () => {
    if (isActivation) {
      navigate('/sensor-folder-assignment')
      return
    }
    setShowLocationSelectModal(true)
  }

  return ownUser && ownUser.folders?.length > 1 ? (
    <>
      {folder && (
        <Alert severity="info" icon={false} sx={classes.alert}>
          <Grid container spacing={1} sx={classes.gridContainer}>
            <Grid size={0.5}>
              <PlaceOutlinedIcon sx={classes.locationIcon} fontSize="small" />
            </Grid>

            <Grid size={9} sx={classes.addressGrid}>
              <Typography variant="body2" className="fs-exclude" sx={isMobile ? classes.truncatedText : undefined}>
                {formatAddress(folder.information.address)}
              </Typography>
            </Grid>

            <Grid size={2.5}>
              <Button size="small" variant="text" sx={classes.changeButton} onClick={handleLocationChange}>
                Change
              </Button>
            </Grid>
          </Grid>
        </Alert>
      )}
      <LocationSelectModal
        open={showLocationSelectModal}
        folderIds={ownUser?.folders || []}
        onClose={() => setShowLocationSelectModal(false)}
        onSelect={(newFolderId) => {
          navigate(`/dashboard/${newFolderId}/devices`)
        }}
        selectedFolderId={selectedFolderId}
      />
    </>
  ) : null
}

export default SelectedFolderBanner
